<!-- @veltra/icons generated sha256:46acd10d8e1ee92b gen:8 source:src/svg/normal/remove-filled.svg -->
<script setup lang="ts">
defineOptions({ name: 'RemoveFilled' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m2.991-6.5H5.01a.51.51 0 0 1-.509-.504.51.51 0 0 1 .509-.496h5.982a.51.51 0 0 1 .509.504.51.51 0 0 1-.509.496"
    />
  </svg>
</template>
